import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisVertical } from "@fortawesome/pro-regular-svg-icons";
import { t } from "i18next";

export type EllipsesMenuExerciseWeeksProps = {
  onChangeExercise: () => void;
  onDelete: () => void;
  onComment: () => void;
  onWeight: (e: any) => void;
  activeWeight: boolean;
};

const EllipsesMenuExerciseWeeks: React.FC<EllipsesMenuExerciseWeeksProps> = ({
  onChangeExercise,
  onDelete,
  onComment,
  onWeight,
  activeWeight,
}) => {
  return (
    <Menu as="div" className="flex-none absolute ">
      <MenuButton className="mb-1 block p-2 text-gray-600 hover:text-gray-900">
        <span className="sr-only">Open options</span>
        <FontAwesomeIcon
          icon={faEllipsisVertical}
          aria-hidden="true"
          className="h-5 w-5"
        />
      </MenuButton>
      <MenuItems className="absolute left-0 top-full mt-1 z-50 w-auto origin-top-left rounded-md bg-white shadow-lg ring-1 ring-gray-900/5 transition focus:outline-none">
        <MenuItem>
          <div
            onClick={onChangeExercise}
            className="block px-3 py-1 text-sm leading-6 text-gray-600 hover:text-gray-900 cursor-pointer"
          >
            {t("trainingEditor.change_equivalent")}
          </div>
        </MenuItem>
        <MenuItem>
          <div
            onClick={onComment}
            className="block px-3 py-1 text-sm leading-6 text-gray-600 hover:text-gray-900 cursor-pointer"
          >
            {t("trainingEditor.edit_comment")}
          </div>
        </MenuItem>

        {activeWeight && (
          <MenuItem>
            <div
              onClick={onWeight}
              className="block px-3 py-1 text-sm leading-6 text-gray-600 hover:text-gray-900 cursor-pointer"
            >
              {t("user.views.weight")}
            </div>
          </MenuItem>
        )}

        <MenuItem>
          <div
            onClick={onDelete}
            className="block px-3 py-1 text-sm leading-6 text-gray-600 hover:text-gray-900 cursor-pointer"
          >
            {t("user.views.delete")}
          </div>
        </MenuItem>
      </MenuItems>
    </Menu>
  );
};

export default EllipsesMenuExerciseWeeks;
